"use client"

import Image from 'next/image';
import React, { useReducer, useState } from 'react';
import { ThankYou } from '../ThankYou';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import RansomwareReportMain from "../../assets/ransomware_2023_year_in_review_coverss.png";


// Reducer function to optimize state updates
const formReducer = (state, action) => {
  return { ...state, [action.name]: action.value };
};

const validatePhoneNumber = (value) => {
  const phoneNumber = parsePhoneNumberFromString(value || "");
  return phoneNumber && phoneNumber.isValid();
};

function RansomwareReport({ blok }) {
  // Optimized state management using useReducer
  const [open, setOpen] = useState(false);

  const validationSchema = yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    company: yup.string().required("Company Name is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    phone: yup.string()
      .matches(/^[\d\s]+$/, 'Phone number must contain only digits')
      .min(10, 'Phone number must be at least 10 digits')
      .max(15, 'Phone number must be at most 15 digits') // optional upper limit
      .required('Phone number is required'),
    jobTitle: yup.string().required("Job Title is required"),
    country: yup.string().required("Country is required"),
  });

  const { values: formData, handleChange, handleSubmit, errors, resetForm } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      company: "",
      email: "",
      phone: "",
      jobTitle: "",
      country: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      setOpen(true)
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subject: "Form filled : Ransomware Report", body: generateTable() }),
      });
      resetForm();
      const result = await response.json();
      if (result.success) downloadPDF();
    }
  });


  function generateTable() {
    return `<table>
      <tr>
        <td>First Name</td>
        <td>${formData.firstName}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>${formData.lastName}</td>
      </tr>
      <tr>
        <td>Last Name</td>
        <td>${formData.company}</td>
      </tr>
      <tr>
        <td>Email</td>
        <td>${formData.email}</td>
      </tr>
       <tr>
        <td>Email</td>
        <td>${formData.phone}</td>
      </tr>
      <tr>
        <td>Job Title</td>
        <td>${formData.jobTitle}</td>
      </tr>
      <tr>
        <td>Country</td>
        <td>${formData.country}</td>
      </tr>
    </table>`
  }

  const downloadPDF = () => {
    const link = document.createElement('a');
    link.href = blok?.FileDownload?.filename
    link.download = 'Securin-ransomware-report.pdf';
    link.target = "_blank";
    link.click();
  };


  return (
    <div className=' w-full'>
      <div className='bg-asmPageMiddleBG bg-asmPageTopBG bg-no-repeat bg-cover pb-10  w-full' style={{
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
        // maxWidth: 1920,
        // margin: 'auto'
      }}>
        <div className="relative lg:flex flex-col items-center py-8 max-w-[1920px] m-auto ">
          <div className="font-aileron py-20 lg:pt-32 text-center font-bold">
            <div className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[80px] lg:w-[65%] m-auto leading-[110%]">
              Ransomware Report 2023 Year in Review
            </div>
            {/* <div className="font-lato mt-20 text-[14px] w-[80%] lg:w-[65%] m-auto lg:text-[18px] font-normal">
              Our latest ransomware report is out, revealing a concerning evolution in cybersecurity threats throughout 2023.
            </div> */}
          </div>
        </div>
        <div className="h-full lg:max-w-[1198px] bg-white rounded-[40px] m-auto shadow-lg mb-20">
          <div className='flex justify-center items-center p-4 lg:p-14'>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-40 lg:gap-10 w-[1920px] max-w-7xl">
              <div className="text-center lg:mb-0 flex flex-col gap-4">
                <p className='bg-custom-radial bg-clip-text text-transparent font-bold font-lato lg:text-[32px] text-[18px] text-center lg:text-left lg:w-[70%] mb-10 lg:mb-2'>
                  Ransomware Report 2023 Year in Review
                </p>
                <div className="w-full md:w-full flex items-center justify-center mx-auto md:mx-0 mb-4 md:mb-8">
                  <img src={"/images/ransomware_2023_year_in_review_coverss.png"} alt="Ransomware Report" />
                </div>
                <div className='text-left flex flex-col gap-2'>
                  <p className='text-[20px] lg:!text[20px] font-lato'>Our latest ransomware report is out, revealing a concerning evolution in the cybersecurity threat landscape throughout 2023. In this report, we analyze the newly associated vulnerabilities from the past year and present overall trends, observations, and recommendations to counter ransomware threats.
                  </p>
                  <h1 className='text-[20px] lg:!text[20px] font-lato' style={{ color: "##E56717" }}>Download this Report and get:</h1>
                  <ul className='font-lato text-[16px] lg:text-[20px] w-[90%] mx-auto lg:mx-0 lg:text-start lg:list-disc pl-4'>
                    <li>Most Weaponised Vulnerabilities</li>
                    <li>Ransomware-Associated vulnerability trends</li>
                    <li>Which threat groups are utilizing ransomware</li>
                  </ul>
                </div>

              </div>
              <div>
                <form className="grid grid-cols-1 gap-4 font-lato" onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <InputField label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="Enter Your First Name" />
                      {errors.firstName && <p className="py-2"><span className="text-red-500">{errors.firstName}</span></p>}
                    </div>
                    <div>
                      <InputField label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Enter Your Last Name" />
                      {errors.lastName && <p className="py-2"><span className="text-red-500">{errors.lastName}</span></p>}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <InputField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Enter Your Email" />
                      {errors.email && <p className="py-2"><span className="text-red-500">{errors.email}</span></p>}
                    </div>
                    <div>
                      <InputField label="Phone/Mobile" name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="Enter Your Number" />
                      {errors.phone && <p className="py-2"><span className="text-red-500">{errors.phone}</span></p>}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                    <InputField label="Job Title" name="jobTitle" value={formData.jobTitle} onChange={handleChange} placeholder={"Enter Your Job Title"} />
                    {errors.jobTitle && <p className="py-2"><span className="text-red-500">{errors.jobTitle}</span></p>}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                    <InputField label="Company" name="company" value={formData.company} onChange={handleChange} placeholder="Enter Your Company" />
                    {errors.company && <p className="py-2"><span className="text-red-500">{errors.company}</span></p>}
                  </div>
                  <div>
                    <InputField label="Country" name="country" value={formData.country} onChange={handleChange} placeholder="Enter Your Country" />
                    {errors.country && <p className="py-2"><span className="text-red-500">{errors.country}</span></p>}
                  </div>
                  {/* <TextAreaField label="Message" name="message" value={formData.message} onChange={handleChange} placeholder="Enter Your Message" /> */}
                  <div className="text-center lg:w-[532px]">
                    <button type="submit"
                      className="bg-[#EF7B22] font-lato text-white px-2 rounded hover:bg-[#d7691d] transition duration-150 w-full lg:w-[532px] lg:h-[69px] h-10 lg:text-[24px] text-[18px]">
                      Submit Form
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {open && <ThankYou onClose={setOpen} onClick={downloadPDF} title={blok.ThankYouText} subtitle={blok.ThankYouSubText} />}
        {/* <Footer blok={blok} /> */}
      </div>
    </div>
  );
}

// Reusable Input Field Component
const InputField = ({ label, name, value, onChange, type = "text", placeholder }) => (
  <div>
    <label className="block text-[18px] lg:text-[24px] font-bold bg-custom-radial bg-clip-text text-transparent">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
    />
  </div>
);

// Reusable Select Field Component
const SelectField = ({ label, name, value, onChange, options }) => (
  <div>
    <label className="block text-[18px] lg:text-[24px] font-bold bg-custom-radial bg-clip-text text-transparent">{label}</label>
    <select
      name={name}
      value={value}
      onChange={onChange}
      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-14"
    >
      <option value="">- Select -</option>
      {options.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </select>
  </div>
);

// Reusable Textarea Field Component
const TextAreaField = ({ label, name, value, onChange, placeholder }) => (
  <div>
    <label className="block text-[18px] lg:text-[24px] font-bold bg-custom-radial bg-clip-text text-transparent">{label}</label>
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm h-32"
    />
  </div>
);

export default RansomwareReport;